module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "query-term clearfix"
  }, [_c('h5', {
    staticClass: "col-xs-7"
  }, [_vm._v(_vm._s(_vm.field.label || _vm.fieldName))]), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeSelect),
      expression: "typeSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disableType
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.field.availableTypes), function(availableType) {
    return _c('option', {
      key: availableType.name,
      domProps: {
        "value": availableType.name
      }
    }, [_vm._v(_vm._s(availableType.label || availableType.name))])
  }))]), _vm._v(" "), _c(_vm.getFieldType(), {
    tag: "component",
    attrs: {
      "params": _vm.paramSet,
      "field": _vm.field
    },
    on: {
      "update:params": function($event) {
        _vm.paramSet = $event
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-141de389"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/QueryTerm.vue
// module id = 1084
// module chunks = 0